// Tag Util
/* eslint standard/no-callback-literal:0 */

import app from '../app.jsx'
import _ from 'lodash'
import Util from './util.jsx'
import DateUtil from './dateutil.jsx'

function _createTask (task, attachment, bFileDeleted, callback) {
  if (task) {
    task.userId = task.userId || app.loggedInId
    task.createdById = app.loggedInId

    const params = { query: { $client: {} } }
    if (attachment) {
      params.query.$client.attachment = attachment
    }

    if (bFileDeleted) {
      params.query.$client.attachmentDelete = bFileDeleted
    }

    app
      .service('/api/project/plannertask')
      .create(task, params)
      .then(_createRes => {
        if (task.activityId) {
          _recalculateActivitySchedules(task.activityId, callback)
        } else {
          callback(null)
        }
      })
      .catch(createErr => {
        app.debug('TaskUtil: _createTask Error', createErr)
        callback(null, createErr)
      })
  }
}

function _updateTask (taskId, task, attachment, bFileDeleted, callback) {
  if (taskId && task) {
    task.userId = task.userId || app.loggedInId

    const params = { query: { $client: {} } }
    if (attachment) {
      params.query.$client.attachment = attachment
    }

    if (bFileDeleted) {
      params.query.$client.attachmentDelete = bFileDeleted
    }

    app
      .service('/api/project/plannertask')
      .patch(taskId, task, params)
      .then(_updateRes => {
        if (task.activityId) {
          _recalculateActivitySchedules(task.activityId, callback)
        } else {
          callback(null)
        }
      })
      .catch(updateErr => {
        app.debug('TaskUtil: _updateTask Error', updateErr)
        callback(null, updateErr)
      })
  }
}

function _removeTask (taskId, callback) {
  if (taskId) {
    app
      .service('/api/project/plannertask')
      .remove(taskId)
      .then(deleteRes => {
        if (deleteRes.activityId) {
          _recalculateActivitySchedules(deleteRes.activityId, callback)
        } else {
          callback(null)
        }
      })
      .catch(deleteErr => {
        app.debug('TaskUtil: _removeTask Error', deleteErr)
        callback(null, deleteErr)
      })
  }
}

function _searchActivity (projectId, extraQuery, callback) {
  const itemParams = {
    query: {
      projectId: projectId,
      type: { $in: ['time-activity'] },
      $select: ['title', 'isActive', 'phaseNo', 'projectId'],
      isActive: true,
      $client: {
        subObjects: {
          project: ['budget']
        }
      },
      $sort: {
        phaseNo: 1,
        orderNo: 1
      }
    }
  }

  if (extraQuery) {
    if (extraQuery.activePhaseNos) {
      itemParams.query.phaseNo = { $in: extraQuery.activePhaseNos }
    }
  }

  app
    .service('/api/project/budgetitem')
    .find(itemParams)
    .then(itemRes => {
      if (itemRes) {
        const options = itemRes.data.map(obj => {
          const phases = obj.project.budget.phases
          const phaseName =
            phases && phases.length > 0 ? phases[obj.phaseNo - 1].title : ''
          const title =
            phaseName === '' ? obj.title : `${obj.title} - ${phaseName}`
          return { label: title, value: obj.id, isActive: obj.isActive }
        })

        callback(options)
      } else {
        callback([])
      }
    })
    .catch(err => {
      app.debug('TaskUtil: _onSearchActivity Error', err)
      callback([])
    })
}

function _getDateSchedule (userId, date, callback) {
  const params = {
    query: {
      userIds: [userId],
      fromDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      toDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1),
      clientTimezoneOffset: new Date().getTimezoneOffset()
    }
  }

  app
    .service('/api/users/scheduletime')
    .find(params)
    .then(result => {
      let timeAvailable = 0
      if (result.data.length > 0 && result.data[0]) {
        result.data[0].schedules.map(obj => {
          timeAvailable = obj.timeAvailable
        })

        callback(timeAvailable)
      }
    })
    .catch(err => {
      app.debug('PageSchedule: _getSchedule ERROR ', err)
      callback(480) // default time 8 * 60
    })
}

function _getTimecardDataFromTask (
  task,
  canUseRemainingHours = false,
  canUsePlannedHours = false,
  plannedDate = null
) {
  const totalScheduledHours = _.sumBy(
    task.schedules,
    schedule => schedule.noHours || 0
  )
  let remaingHours = totalScheduledHours - task.timeSpent / 60
  remaingHours = remaingHours >= 0 ? remaingHours : 0
  let noHours = 0

  // if task planned date and schedule date equal means then get noHours for that particular day
  if (plannedDate) {
    task.schedules.map(schedule => {
      if (DateUtil.isDateEqual(schedule.date, plannedDate)) {
        noHours = schedule.noHours * 60
      }
    })
  }

  // if click add timecard icon then in timecard page it should create timecard with planned hours for particular day
  if (canUsePlannedHours) {
    remaingHours = noHours / 60 // noHours[plannedHours] = 6 => create timecard with 6 hours
    remaingHours = remaingHours >= 0 ? remaingHours : 0 // if we have remainghours it will return remaingHours otherwise it will return 0
  }

  // if task completed means it should create timecard with remaining hours
  if (canUseRemainingHours) {
    remaingHours = task.duration / 60 - noHours / 60 // duration = 12 and plannedHours(noHours) = 4 => (12 - 4) = 8(create timecard with 8 hours)
    remaingHours = remaingHours >= 0 ? remaingHours : 0
  }

  return {
    projectId: task.projectId || null,
    activityId: task.activityId || null,
    activity: task.activity ? task.activity.title : '',
    userId: task.userId,
    taskId: task.id,
    timeTaken: remaingHours <= 24 ? remaingHours * 60 : 0
  }
}

function _recalculateActivitySchedules (activityId, callback) {
  const params = {
    query: { activityId: activityId }
  }

  return app
    .service('/api/project/plannertask')
    .find(params)
    .then(taskRes => {
      let allcoatedHours = 0
      const activitySchedules = []

      taskRes.data.map(task => {
        if (task.schedules && task.schedules.length > 0) {
          task.schedules.map(schedule => {
            const actvitySchedule = _.find(activitySchedules, obj =>
              Util.isDateEqual(new Date(schedule.date), new Date(obj.date))
            )

            allcoatedHours += schedule.noHours
            if (actvitySchedule) {
              actvitySchedule.noHours += schedule.noHours
            } else {
              // Create if not exists
              activitySchedules.push({
                date: schedule.date,
                noHours: schedule.noHours
              })
            }
          })
        }
      })

      const updateObj = {
        schedules: activitySchedules,
        allcoatedHours: allcoatedHours
      }

      return app.service('/api/project/budgetitem').patch(activityId, updateObj)
    })
    .then(_activityUpdateRes => {
      callback(null)
    })
    .catch(err => {
      app.debug('TaskUtil: _recalculateActivitySchedules ERROR ', err)
      callback(null)
    })
}

const TaskUtil = {}
TaskUtil.createTask = _createTask
TaskUtil.updateTask = _updateTask
TaskUtil.removeTask = _removeTask
TaskUtil.searchActivity = _searchActivity
TaskUtil.getDateSchedule = _getDateSchedule
TaskUtil.getTimecardDataFromTask = _getTimecardDataFromTask

export default TaskUtil
